module.exports = __webpack_public_path__ + "698d320aef8bcde1662d3a75cc4160e2.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/amex.svg
// module id = 490
// module chunks = 74